.card {
  display: flex;
  flex-direction: column;
  gap: var(--tuna-spacing-2);
  padding: var(--tuna-spacing-3);
  border: 1px solid var(--tuna-border-default);
  border-radius: var(--tuna-shape-borderRadius);
  background: var(--tuna-surface-elevated);
}

.cardActive {
  outline: 2px solid var(--tuna-palette-primary-main);
  outline-offset: -2px;
}

.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--tuna-spacing-2);
}

.title {
  font-size: var(--tuna-typography-body1-fontSize);
  font-weight: 600;
  margin: 0;
}

.copy {
  font-size: var(--tuna-typography-body2-fontSize);
  color: var(--tuna-content-secondary);
  margin: 0;
}

.caption {
  font-size: var(--tuna-typography-caption-fontSize);
  color: var(--tuna-content-muted);
  margin: 0;
}
